
import { useCallback } from "react";
import { saveDemoRequestToDatabase } from "@/services/demoRequestService";
import { supabase } from "@/lib/supabase";
import { useAuthState } from "./authentication/useAuthState";
import { useAuthMethods } from "./authentication/useAuthMethods";

export const useAuthentication = () => {
  const {
    user, 
    setUser,
    session,
    setSession,
    isLoading,
    setIsLoading
  } = useAuthState();
  
  const { signIn, signUp: baseSignUp, signOut } = useAuthMethods(setIsLoading);
  
  const signUp = useCallback(async (formData: any) => {
    try {
      // Check for saved demo request data before signing up
      const demoRequestData = sessionStorage.getItem('demoRefundRequest');
      
      const result = await baseSignUp(formData);
      
      if (result.error) {
        return result;
      }
      
      // Don't save demo request data immediately after signup
      // Wait for email confirmation before proceeding
      if (result.needsConfirmation) {
        // Store demo request data temporarily for after confirmation
        if (demoRequestData) {
          sessionStorage.setItem('pendingDemoRequest', demoRequestData);
        }
      } else {
        // If no confirmation needed, get the current user data and save demo request
        const { data: { user: newUser } } = await supabase.auth.getUser();
        
        if (demoRequestData && newUser) {
          await saveDemoRequestToDatabase(newUser, demoRequestData);
        }
      }
      
      return result;
    } catch (error) {
      console.error("Error in signUp:", error);
      return { error };
    }
  }, [baseSignUp]);

  return {
    user,
    setUser,
    session,
    setSession,
    isLoading,
    setIsLoading,
    signIn,
    signUp,
    signOut
  };
};
